import { getMemoryChargedData } from '../api/api';
// SET_MEMEORY_CHARGED
export const setMemoryCharged = (memoryChargedData) => ({
    type: 'SET_MEMEORY_CHARGED',
    data: memoryChargedData
});

// GET_MEMEORY_CHARGED
export const getMemoryCharged = (memoryChargedData) => ({
    type: 'GET_MEMEORY_CHARGED',
    data: memoryChargedData
});


export const starSetMemoryCharged = (memoryChargedData = {}) => {
    return (dispatch) => {
        dispatch(setMemoryCharged(memoryChargedData))
    }
};

// SET_ALTERNATE_MEMEORY_CHARGED
export const setAlternateMemoryCharged = (alternatememoryChargedData) => ({
    type: 'SET_ALTERNATE_MEMEORY_CHARGED',
    data: alternatememoryChargedData
});

// GET_ALTERNATE_MEMEORY_CHARGED
export const getAlternateMemoryCharged = (alternatememoryChargedData) => ({
    type: 'GET_ALTERNATE_MEMEORY_CHARGED',
    data: alternatememoryChargedData
});


export const starSetAlternateMemoryCharged = (alternatememoryChargedData = {}) => {
    return (dispatch) => {
        dispatch(setAlternateMemoryCharged(alternatememoryChargedData))
    }
};

// SET_DIGITAL_CHARGED
export const setDigitalCharged = (digitalChargedData) => ({
    type: 'SET_DIGITAL_CHARGED',
    data: digitalChargedData
});

// GET_DIGITAL_CHARGED
export const getDigitalCharged = (digitalChargedData) => ({
    type: 'GET_DIGITAL_CHARGED',
    data: digitalChargedData
});


export const starSetDigitalCharged = (digitalChargedData = {}) => {
    return (dispatch) => {
        dispatch(setDigitalCharged(digitalChargedData))
    }
};

export const starGetMemoryCharged = (idBenef, idPartner) => {
    return () => {
        return getMemoryChargedData(idBenef, idPartner);
    }
};


// WEBPACK FOOTER //
// ./src/actions/memoryCharged.js